export default __webpack_public_path__ + "static/img_2-f5805d2b34ad6ce04c042fbd49781cb3.webp";